/* eslint-disable import/no-namespace */
/* eslint-disable no-debugger */
import React from "react"
import { connect } from "react-redux"
import { PropTypes } from "prop-types"
import { FormControl } from "react-bootstrap"
//import { showModal } from "ducks/modals.js"  // eslint-disable-line import/no-extraneous-dependencies
import userManager from '../../../userManager'
import NewUser from "../../../containers/user/newuser"
import UserSearchResult from "../../../containers/user/usersearchresult"
import ContentWrapper from "../../layout/ContentWrapper"
import UserSearch from "../../userSearch"
import * as Constants from './constants'
import { getUsers, approveUser, revokeAccess } from './api'

class UserManagement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addNewUserMode: false,
      showSearchResultsMode: false,
      searchBy: Constants.SearchByEnum.Status,
      searchValue: Constants.UserStatusEnum.PendingApproval,
      freeTextSearch: false,
      searching: true,
      users: [],
      userList: []
    }
    this.handleAddUser = this.handleAddUser.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.setModes = this.setModes.bind(this);
    this.searchUser = this.searchUser.bind(this);
    this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
    this.handleApproveUser = this.handleApproveUser.bind(this);
    this.handleRevokeAccess = this.handleRevokeAccess.bind(this);
    this.handleGenerateUserList = this.handleGenerateUserList.bind(this);

    this.searchValueFieldRef = React.createRef;
  }

  componentDidMount() {
    const { oidc } = this.props;
    if (oidc.user == null) {
      userManager.signinRedirect();
    }
    else {
      this.searchUser();
    }
  }

  handleApproveUser(evt) {
    const userRequestId = evt.target.dataset.key;
    const token = this.props.oidc.user.access_token;
    const _this = this;
    approveUser(userRequestId, token).then(function () {
      _this.searchUser();
    }).catch(function (error) {
      console.log('Approve user error', error);
    });
  }

  handleRevokeAccess(evt) {
    const userId = evt.target.dataset.key;
    const token = this.props.oidc.user.access_token;
    const _this = this;
    revokeAccess(userId, token).then(function () {
      _this.searchUser();
    }).catch(function (error) {
      console.log('Revoke user error', error);
    });
  }

  handleGenerateUserList() {
    const { users } = this.state;
    const userList = [];
    const _this = this;
    users.map(function (user) {
      const { firstName, lastName, emailAddress, usbcMembershipId, role, ssoUserId, status } = user;
      userList.push({
        firstName,
        lastName,
        emailAddress,
        usbcMembershipId,
        role,
        ssoUserId,
        status
      });
      _this.setState({ userList });
    });
  }

  handleAddUser = () => {
    this.setModes(true, false);
  }

  handleSearch = () => {
    this.searchUser();
  }

  handleSearchValueChange = (evt) => {
    const searchValue = evt.target.value;
    // const searchNode =  this.searchValueFieldRef.current
    // searchNode.value = ''
    this.setState({
      addNewUserMode: false,
      showSearchResultsMode: false,
      searchValue: searchValue,
      users: []
    });
  }

  handleSearchByChange = (event) => {
    const searchBy = event.target.value;
    let freetextsearch = true;
    
    if ((searchBy == Constants.SearchByEnum.Role) || (searchBy == Constants.SearchByEnum.Status) || (searchBy == Constants.SearchByEnum.All)) {
      freetextsearch = false;
    }
    this.setModes(false, false, freetextsearch, searchBy);
  }

  setModes = (newusermode, searchresultmode, freetextsearch = null, searchby = null) => {
    this.setState({
      addNewUserMode: newusermode,
      showSearchResultsMode: searchresultmode,
      freeTextSearch: freetextsearch !== null ? freetextsearch : this.state.freeTextSearch,
      searchBy: searchby !== null ? searchby : this.state.searchBy
    });
  }

  setSearchTextField = () => {
    const fldtype = (this.state.searchBy == Constants.SearchByEnum.Email) ? 'email' : 'text'
    return (<FormControl type={fldtype} ref={elem => this.searchValueFieldRef = elem} placeholder='Enter value' style={{ minWidth: '220px' }} onChange={this.handleSearchValueChange} />)
  }

  setSelectValues = () => {
    const attrs = {
      name: 'searchvalue',
      componentClass: 'select',
      onChange: this.handleSearchValueChange,
      style: { minWidth: "220px", borderRadius: '0' }
    }
    switch (this.state.searchBy) {
      case Constants.SearchByEnum.Status:
        {
          return (
            <FormControl {...attrs} defaultValue={Constants.UserStatusEnum.Active}>
              <option value={Constants.UserStatusEnum.Active}>{Constants.UserStatus.Active}</option>
              <option value={Constants.UserStatusEnum.Deactivated}>{Constants.UserStatus.Deactivated}</option>
              <option value={Constants.UserStatusEnum.InviteExpired}>{Constants.UserStatus.InviteExpired}</option>
              <option value={Constants.UserStatusEnum.PendingUserAcceptance}>{Constants.UserStatus.PendingUserAcceptance}</option>
            </FormControl>
          );
        }
      case Constants.SearchByEnum.Role:
        {
          return (
            <FormControl {...attrs}>
              <option value={Constants.RoleEnum.Director}>Event Director</option>
              <option value={Constants.RoleEnum.Administrator}>Administrator</option>
            </FormControl>);
        }
    }
  }

  isFreeText = () => {
    const { searchBy, freeTextSearch } = this.state;
    return (searchBy != Constants.SearchByEnum.All && freeTextSearch);
  }

  isSelect = () => {
    const { searchBy, freeTextSearch } = this.state;
    const validRole = searchBy === Constants.SearchByEnum.All ||
      searchBy === Constants.SearchByEnum.Status ||
      searchBy === Constants.SearchByEnum.Role;
    return validRole && !freeTextSearch;
  }

  searchUser = () => {
    const { searchBy, searchValue } = this.state;
    const token = this.props.oidc.user.access_token;
    const _this = this;
    this.setModes(false, false);
    this.setState({ searching: true, users: [], userList: [] });

    getUsers(searchBy, searchValue, token).then(function (users) {
      _this.setState({ searching: false, showSearchResultsMode: true, users: users.data });
    }).catch(function (error) {
      console.log('Search results error', error);
      _this.setState({ searching: false });
    });
  }

  render() {
    const {
      showSearchResultsMode,
      addNewUserMode,
      searching,
      users,
      userList
    } = this.state;

    const isSelect = this.isSelect();
    const generateReport = (users !== null ? users.length > 0 : false);

    const userSearchResultProps = {
      users: users,
      handleApproveClick: this.handleApproveUser,
      handleRevokeClick: this.handleRevokeAccess
    };

    const userSearchProps = {
      userList: userList,
      searching: searching,
      isSelect: isSelect,
      generateReport: generateReport,
      setSearchTextField: this.setSearchTextField,
      setSelectValues: this.setSelectValues,
      handleSearch: this.handleSearch,
      handleSearchByChange: this.handleSearchByChange,
      handleGenerateUserList: this.handleGenerateUserList,
      handleAddUser: this.handleAddUser
    };
    
    return (
      <ContentWrapper>
        <UserSearch {...userSearchProps} />
        {
          showSearchResultsMode && <UserSearchResult {...userSearchResultProps} />
        }
        {
          addNewUserMode && <NewUser />
        }
        {searching && <span>Loading...</span>}
      </ContentWrapper >);
  }
}

UserManagement.propTypes = {
  oidc: PropTypes.object,
  dispatch: PropTypes.func
}

const mapStateToProps = ({ oidc }) => {
  return {
    oidc: { ...oidc }
  }
}

export default connect(mapStateToProps, null)(UserManagement)


// WEBPACK FOOTER //
// ./src/components/pages/UserManagement/index.js